import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_LAB_DEPT } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const getAllLabDept = createAsyncThunk(
  "labDepartments/get-all-lab-dept",
  async (data) => {
    try {
      const api = useAxios();
      const config = {
        params: {
          search: data.search,
          pageSize: data.pageSize,
          pageNumber: data.pageNumber,
          sortField: data.sortField,
          sortDirection: data.sortDirection,
        },
      };
      const response = await api.get(URL_LAB_DEPT, config);
      return response.data;
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { getAllLabDept };
